/* 🤖 this file was generated by svg-to-ts */
export const matIconWaterDamage: {
  name: 'water-damage';
  data: string;
} = {
  name: 'water-damage',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 3 2 12h3v8h14v-8h3L12 3zM7 18v-7.81l5-4.5 5 4.5V18H7zm7-4c0 1.1-.9 2-2 2s-2-.9-2-2 2-4 2-4 2 2.9 2 4z"/></svg>`
};
